import { render } from "./HeadComponent.vue?vue&type=template&id=28722831&scoped=true"
import script from "./HeadComponent.vue?vue&type=script&lang=js"
export * from "./HeadComponent.vue?vue&type=script&lang=js"

import "./HeadComponent.vue?vue&type=style&index=0&id=28722831&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28722831"]])

export default __exports__